import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-the-j05-chat-screen" }
const _hoisted_2 = { class: "p-the-j05-chat-screen__chat" }
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 0,
  class: "p-unread-line"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_J05ChatScreenPanel = _resolveComponent("J05ChatScreenPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatLog, (chat, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "p-the-j05-chat-screen__chat__item",
          key: chat.rowNo,
          id: `chat-${chat.rowNo}`
        }, [
          (chat.rowNo === _ctx.unreadRowNo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 未読メッセージ "))
            : _createCommentVNode("", true),
          _createVNode(_component_J05ChatScreenPanel, {
            "chat-data": {
            ...chat,
            key,
            chatLog: _ctx.chatLog 
          },
            "unread-key-no": _ctx.unreadRowNo,
            "partner-user-image": _ctx.partnerUserImage
          }, null, 8, ["chat-data", "unread-key-no", "partner-user-image"])
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}